<template>
    <v-container>

        <Titulo></Titulo>

        <div class="text-center">

            <br><br>

            <h4 style="font-family: Poppins; font-style: normal; font-weight: 700; font-size: 20px; line-height: 25px; letter-spacing: -0.01em;
                text-transform: uppercase; color: #2D387C; text-transform: uppercase;">¡Oh no! {{
                    capitalizeName(userData.name) }}, lo sentimos, ha ocurrido un error inesperado.
            </h4>

        </div>

        <br>
        <br>

        <div :class="image">
            <v-card>
                <v-img contain max-height="300" :src="ErrorImage" max-width="300" style="margin:auto;" />
            </v-card>
        </div>

        <br>
        <br>

        <div :class="image" style="width: 400px;">
            <v-card class="text-center" style="width: 720px;">
                <label
                    style="font-family: Arial; font-style: normal; font-weight: 400; font-size: 15px; line-height: 20px; text-align: center; color: #232323;">
                    Al parecer ocurrió un error con el sistema de
                    pago, pero no te preocupes que debe ser
                    temporal.
                </label>
            </v-card>
        </div>

        <br>

        <div class="text-center">
            <label
                style="font-family: Arial; font-style: normal; font-weight: 400; font-size: 15px; line-height: 20px; text-align: center; color: #232323; opacity: 0.75;">
                Quieres ver otros seguros?
            </label>
        </div>

        <br>

        <div class="text-center">
            <v-btn style="padding: 12px 15px; gap: 10px; width: 345px; height: 50px; background: #4F74E3; box-shadow: 4px 8px 24px rgba(51, 51, 204, 0.12);
                        border-radius: 12px; text-transform:inherit; color: white;" elevation="0"
                @click="returnPage()">
                <v-icon color="white" dark left>
                    mdi-arrow-left
                </v-icon>
                Volver a pagos
            </v-btn>
        </div>

    </v-container>
</template>

<script>
import ErrorImage from "@/assets/images/Error.png";
import Titulo from "../components/Titulo.vue";
import CryptoJS from 'crypto-js';

export default {
    components: { Titulo },
    data() {
        return {
            secretKey: process.env.VUE_APP_CRYPT,
            userData: {
                name: null,
                surname: null,
                serialNumber: null,
                rut: null,
                typeIsapre: null,
                region: null,
                commune: null,
                comuneCode: null,
                regionCode: null,
                address: null,
                email: null,
                phoneNumber: null,
                couponId: null,
                stepId: null,
                old: null,
                dates: null,
                salud: null,
                questionOne: null,
                questionTwo: null,
                questionThree: null,
                typePlan: null,
                addressNumber: null,
                addressDepto: null,
                sonExist: false,
                arrayTypesBenef: [],
                oldAux: null,
                day: null,
                month: null,
                year: null,
            },
            image: null,
            ErrorImage,
            screen: window.screen.width,
        }
    },
    async mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        document.body.setAttribute('data-sku', 'ONC-008-ERR');

        const userDataAux = sessionStorage.getItem('userData');

        if (userDataAux) {
            const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
            const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
            this.userData = JSON.parse(decryptedDataUser);
        }

        if (this.screen > 800) {
            this.image = 'image'
        } else {
            this.image = 'image2'
        }
    },
    methods: {
        returnPage() {
            const insuranceID = localStorage.getItem('insuranceID');
            this.$router.push({ path: `/og/whatsappBusiness?insuranceID=${insuranceID}` })
        },
        capitalizeName(name) {
            if (!name) return '';
            return name.charAt(0).toUpperCase() + name.slice(1);
        },
    }

}
</script>

<style lang="css" scoped>
.v-alert {
    position: fixed;
    left: 50%;
    bottom: 50px;
    transform: translate(-50%, 100%);
    margin: 0 auto;
}

.image {
    width: 20%;
    margin: auto;
}

.image2 {
    width: 100%;
    margin: auto;
}
</style>
